import { type FC, type ReactNode, useCallback, useId } from "react";
import { Heading, Text } from "@stubhub/broadway-web";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { benefitCardRecipe } from "./styles";

export interface BenefitCardProps {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  sectionId: string;
}

export const BenefitCard: FC<BenefitCardProps> = ({ icon, title, description, sectionId }) => {
  const storePageEvent = useStorePageEvent();
  const styles = benefitCardRecipe();
  const headingId = useId();
  const handleDetailSectionClick = useCallback(() => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.FAN_PROTECT_DETAIL_SECTION_CLICK, sectionId);
  }, [sectionId, storePageEvent]);

  return (
    <div className={styles.card} onClick={handleDetailSectionClick} aria-labelledby={headingId}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.textBlock}>
        <Heading id={headingId} variant="title" size="small" as="h3">
          {title}
        </Heading>
        <Text variant="body" size="small" color="text.subtle">
          {description}
        </Text>
      </div>
    </div>
  );
};
